/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1ApplicationKind } from './V1ApplicationKind'
import {
    V1ApplicationKindFromJSON,
    V1ApplicationKindFromJSONTyped,
    V1ApplicationKindToJSON,
    V1ApplicationKindToJSONTyped
} from './V1ApplicationKind'

/**
 *
 * @export
 * @interface V1CoachApplicationPayload
 */
export interface V1CoachApplicationPayload {
    /**
     *
     */
    kind?: V1ApplicationKind
    /**
     *
     */
    displayName: string
    /**
     *
     */
    specialization?: string
    /**
     *
     */
    experienceYears?: number
    /**
     *
     */
    languages?: Array<string>
    /**
     *
     */
    about: string
    /**
     *
     */
    socialLink?: string
    /**
     *
     */
    certificationsLink?: string
    /**
     *
     */
    email?: string
    /**
     *
     */
    contactName?: string
    /**
     *
     */
    phone?: string
    /**
     *
     */
    address?: string
}

/**
 * Check if a given object implements the V1CoachApplicationPayload interface.
 */
export function instanceOfV1CoachApplicationPayload(
    value: object
): value is V1CoachApplicationPayload {
    if (!('displayName' in value) || value['displayName'] === undefined)
        return false
    if (!('about' in value) || value['about'] === undefined) return false
    return true
}

export function V1CoachApplicationPayloadFromJSON(
    json: any
): V1CoachApplicationPayload {
    return V1CoachApplicationPayloadFromJSONTyped(json, false)
}

export function V1CoachApplicationPayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachApplicationPayload {
    if (json == null) {
        return json
    }
    return {
        kind:
            json['kind'] == null
                ? undefined
                : V1ApplicationKindFromJSON(json['kind']),
        displayName: json['displayName'],
        specialization:
            json['specialization'] == null ? undefined : json['specialization'],
        experienceYears:
            json['experienceYears'] == null
                ? undefined
                : json['experienceYears'],
        languages: json['languages'] == null ? undefined : json['languages'],
        about: json['about'],
        socialLink: json['socialLink'] == null ? undefined : json['socialLink'],
        certificationsLink:
            json['certificationsLink'] == null
                ? undefined
                : json['certificationsLink'],
        email: json['email'] == null ? undefined : json['email'],
        contactName:
            json['contactName'] == null ? undefined : json['contactName'],
        phone: json['phone'] == null ? undefined : json['phone'],
        address: json['address'] == null ? undefined : json['address']
    }
}

export function V1CoachApplicationPayloadToJSON(
    json: any
): V1CoachApplicationPayload {
    return V1CoachApplicationPayloadToJSONTyped(json, false)
}

export function V1CoachApplicationPayloadToJSONTyped(
    value?: V1CoachApplicationPayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        kind: V1ApplicationKindToJSON(value['kind']),
        displayName: value['displayName'],
        specialization: value['specialization'],
        experienceYears: value['experienceYears'],
        languages: value['languages'],
        about: value['about'],
        socialLink: value['socialLink'],
        certificationsLink: value['certificationsLink'],
        email: value['email'],
        contactName: value['contactName'],
        phone: value['phone'],
        address: value['address']
    }
}
